module.exports = __webpack_public_path__ + "static/img/avatar_9.fb60504.png";


//////////////////
// WEBPACK FOOTER
// ./static/avatars/avatar_9.png
// module id = 1600
// module chunks = 61